import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatDialogModule } from '@angular/material/dialog';
import { MatAutocompleteModule } from '@angular/material/autocomplete';

import { EmailVerifyComponent } from './components/email-verify/email-verify.component';
import { CompareValidatorDirective } from './directive/compare-validator.directive';
import { MessageModule } from './message/message.module';
import { TermsAndConditionsComponent } from './components/terms-and-conditions/terms-and-conditions.component';
import { EnrollComponent } from './components/enroll/enroll.component';
import { BlockedComponent } from './components/blocked/blocked.component';
import { RedeemPointsComponent } from './components/redeem-points/redeem-points.component';
import { SellerRewardsDialogComponent } from './components/seller-rewards-dialog/seller-rewards-dialog.component';
import { MaintenanceComponent } from './components/maintenance/maintenance.component';
import {OpenHouseQuizComponent } from './components/open-house-quiz/open-house-quiz';
import { TranslateModule } from '@ngx-translate/core';
import { QuizComponent } from './components/quiz/quiz.component';
import {MatRadioModule} from '@angular/material/radio';
import {MatCheckboxModule} from '@angular/material/checkbox';
import { NgCircleProgressModule } from 'ng-circle-progress';
import {MatGridListModule} from '@angular/material/grid-list';
import {MatCardModule} from '@angular/material/card';
import {MatProgressBarModule} from '@angular/material/progress-bar';
import { MatButtonModule, MatProgressSpinnerModule, MatTableModule, MatTabsModule } from '@angular/material';
import { MatIconModule } from '@angular/material/icon';
import { ProgressInfoPopupComponent } from './components/progress-info-popup/progress-info-popup/progress-info-popup.component';
import { UserAccessValidationComponent } from './components/user-access-validation/user-access-validation/user-access-validation.component';
import { SlickCarouselModule } from 'ngx-slick-carousel';

import { DocumentProofsComponent } from './components/document-proofs/document-proofs/document-proofs.component';
import { DiscussionBoardModule } from './components/discussion-board/discussion-board/discussion-board.module';
import { DndDirective } from '../dnd.directive';
import { CallbackComponent } from '../core/auth/callback.component';
import { ChallengeDetailDrawerComponent } from './components/challenge-detail-drawer/challenge-detail-drawer.component';
import { LeaderboardDetailDrawerComponent } from './components/leaderboard-detail-drawer/leaderboard-detail-drawer.component';
import { DocumentListComponent } from './components/document-list/document-list.component';
import { TakeCourseDrawerComponent } from './components/take-course-drawer/take-course-drawer.component';
import { BookingChallengeDrawerComponent } from './components/booking-challenge-drawer/booking-challenge-drawer.component';
import { ArchitectureChallengeDrawerComponent } from './components/architecture-challenge-drawer/architecture-challenge-drawer.component';
import { TermsDrawerComponent } from './components/terms-drawer/terms-drawer.component';
import { QuizDrawerComponent } from './components/quiz-drawer/quiz-drawer.component';
import { ParticipationChalengeDrawerComponent } from './components/participation-chalenge-drawer/participation-chalenge-drawer.component';
import { TabsComponent } from './components/tabs/tabs.component';
import { ExpandableTabTableComponent } from './components/expandable-tab-table/expandable-tab-table.component';
import { UiModule } from './ui/ui.module';
import { ProductBookingDrawerComponent } from './components/product-booking-drawer/product-booking-drawer.component';
import { ProofOfPerformanceComponent } from './components/proof-of-performance/proof-of-performance.component';
import { TopBannerModule } from '../home/top-banner/top-banner.module';
import { ApproverModule } from '../home/approver/approver.module';
import { NotificationSliderComponent } from '../home/notification-slider/notification-slider.component';
import { ActivityChallengesComponent } from '../home/components/activity-challenges/activity-challenges.component';
import { ActivityChallengeCardComponent } from '../home/components/activity-challenges/activity-challenge-card/activity-challenge-card.component';
import { ActivityChallengeDocumentsComponent } from './components/activity-challenge-documents/activity-challenge-documents/activity-challenge-documents.component';

@NgModule({
  imports: [
    CommonModule,
    MessageModule,
    ReactiveFormsModule,
    FormsModule,
    MatInputModule,
    RouterModule,
    MatSelectModule,
    MatDialogModule,
    TranslateModule,
    MatAutocompleteModule,
    MatRadioModule,
    MatCheckboxModule,
    MatGridListModule,
    NgCircleProgressModule.forRoot(),
    MatCardModule,
    MatProgressBarModule,
    MatProgressSpinnerModule,
    MatTableModule,
    MatIconModule,
    //MatTableModule,
    //MatListModule,
    MatButtonModule,
    MatTabsModule,
    // MatMenuModule,
    // MatIconModule,
    // MatDatepickerModule
    SlickCarouselModule,
    UiModule,
    TopBannerModule,
    DiscussionBoardModule,
    ApproverModule
  ],
  declarations: [
    EmailVerifyComponent,
    CompareValidatorDirective,
    OpenHouseQuizComponent,
    TermsAndConditionsComponent,
    EnrollComponent,
    BlockedComponent,
    RedeemPointsComponent,
    SellerRewardsDialogComponent,
    MaintenanceComponent,
    QuizComponent,
    ProgressInfoPopupComponent,
    UserAccessValidationComponent,
    CallbackComponent,
    DocumentProofsComponent,
    DndDirective,
    ChallengeDetailDrawerComponent,
    LeaderboardDetailDrawerComponent,
    DocumentListComponent,
    TakeCourseDrawerComponent,
    BookingChallengeDrawerComponent,
    ArchitectureChallengeDrawerComponent,
    TermsDrawerComponent,
    QuizDrawerComponent,
    ParticipationChalengeDrawerComponent,
    TabsComponent,
    ExpandableTabTableComponent,
    ProductBookingDrawerComponent,
    ProofOfPerformanceComponent,
    NotificationSliderComponent,
    ActivityChallengesComponent,
    ActivityChallengeCardComponent,
    ActivityChallengeDocumentsComponent,
  ],
  entryComponents: [
    SellerRewardsDialogComponent
  ],
  exports: [
    EmailVerifyComponent,
    CompareValidatorDirective,
    MatInputModule,
    MatSelectModule,
    MatDialogModule,
    MatAutocompleteModule,
    MatCardModule,
    MatProgressBarModule,
    MatProgressSpinnerModule,
    MatTableModule,
    MatIconModule,
    //MatTableModule,
   // MatListModule,
    MatButtonModule,
    MatTabsModule,
    // MatMenuModule,
    // MatIconModule,
    // MatDatepickerModule
    DndDirective,
    ChallengeDetailDrawerComponent,
    LeaderboardDetailDrawerComponent,
    TakeCourseDrawerComponent,
    BookingChallengeDrawerComponent,
    ArchitectureChallengeDrawerComponent,
    DocumentListComponent,
    TermsDrawerComponent,
    QuizDrawerComponent,
    ParticipationChalengeDrawerComponent,
    TabsComponent,
    ProductBookingDrawerComponent,
    ProofOfPerformanceComponent,
    ExpandableTabTableComponent,
    TopBannerModule,
    NotificationSliderComponent,
    ActivityChallengesComponent,
    ActivityChallengeCardComponent,
    ActivityChallengeDocumentsComponent,
    UiModule
  ]
})
export class SharedModule { }
